import BackgroundImage from 'components/BackgroundImageFromUrl/BackgroundImageFromUrl';

BackgroundImage.displayName = 'Card.BackgroundImage';

export default BackgroundImage;
